export const iconFontAwesomeAutomotiveGaugeHigh = (
	<i className="fa-solid fa-gauge-high"></i>
);
